import produce from "immer";

import { ModelState } from "../../../interfaces/modelState";

interface EmailAddressMutationModel {
  oldEmailAddress: string;
  newEmailAddress: string;
}

interface State {
  data: Partial<EmailAddressMutationModel>;
  loading: boolean;
  modelState: ModelState | null;
}

export const initialState: State = {
  data: {
    oldEmailAddress: undefined,
    newEmailAddress: undefined,
  },
  loading: false,
  modelState: null,
};

type Action =
  | { type: "UPDATE_EMAIL_ADDRESS_MUTATION_DATA"; payload: Partial<EmailAddressMutationModel> }
  | { type: "UPDATE_EMAIL_ADDRESS_MUTATION_ERROR"; payload: ModelState }
  | { type: "UPDATE_EMAIL_ADDRESS_MUTATION_FETCH_START" }
  | { type: "UPDATE_EMAIL_ADDRESS_MUTATION_FETCH_ERROR"; payload: ModelState };

export const emailAddressMutationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "UPDATE_EMAIL_ADDRESS_MUTATION_DATA":
      return produce(state, (draft) => {
        draft.data = { ...draft.data, ...action.payload };
      });
    case "UPDATE_EMAIL_ADDRESS_MUTATION_ERROR":
      return produce(state, (draft) => {
        draft.modelState = action.payload;
      });
    case "UPDATE_EMAIL_ADDRESS_MUTATION_FETCH_START":
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case "UPDATE_EMAIL_ADDRESS_MUTATION_FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = action.payload;
      });
  }
};
